import { Helmet } from 'react-helmet-async';
import React from 'react';
import ChangeInsightsSettingsFormContainer from '../../../containers/change-insights/ChangeInsightsSettingFormContainer.jsx';
import requireAuth from '../../../lib/requireAuth.jsx';
import withRouterParams from '../../../lib/withRouterParams.jsx';

const ChangeInsightsSettings = ({ initiativeId, initiativeType, slug }) => (
  <>
    <Helmet>
      <title>Change Insights Customize Dashboard | ChangeSync</title>
    </Helmet>
    <ChangeInsightsSettingsFormContainer
      initiativeId={initiativeId}
      initiativeType={initiativeType}
      slug={slug}
    />
  </>
);

ChangeInsightsSettings.getInitialProps = ({ query }) => ({
  initiativeId: Number(query.initiativeId),
  initiativeType: query.initiativeType,
  slug: query.slug,
});

export default requireAuth(withRouterParams(ChangeInsightsSettings));
